export type BookingSimplifiedCostTelemetryCategory =
  | 'bookingNotFound'
  | 'endpointUnavailable'
  | 'server5xx'
  | 'timeout'
  | 'network'
  | 'schemaMismatch'
  | 'validation';

export type BookingSimplifiedCostRetryMode = 'auto' | 'manual';

export type BookingSimplifiedCostTelemetryEvent =
  | 'booking_simplified_cost_submit_started'
  | 'booking_simplified_cost_submit_succeeded'
  | 'booking_simplified_cost_submit_failed'
  | 'booking_simplified_cost_retry_triggered';

export interface BookingSimplifiedCostTelemetryPayload {
  bookingId: number;
  category?: BookingSimplifiedCostTelemetryCategory;
  retryMode?: BookingSimplifiedCostRetryMode;
}

const isBookingSimplifiedCostTelemetryLoggerEnabled =
  process.env.NODE_ENV === 'development' ||
  process.env.REACT_APP_ENABLE_BOOKING_SIMPLIFIED_COST_TELEMETRY_LOGGER === 'true';

export const emitBookingSimplifiedCostTelemetry = (
  event: BookingSimplifiedCostTelemetryEvent,
  payload: BookingSimplifiedCostTelemetryPayload
): void => {
  if (!isBookingSimplifiedCostTelemetryLoggerEnabled) {
    return;
  }

  console.log('[Telemetry][BookingSimplifiedCost]', event, payload);
};
